import {
    CHANGE_PREFERRED_LANGUAGE
  } from "../../actionTypes";
  
  const initialState = {};
  
  export default (state = initialState, { type, payload }) => {
    switch (type) {
      case CHANGE_PREFERRED_LANGUAGE:
        return { ...state, preferredLanguage: payload };
      default:
        return state;
    }
  };
  